import React, { useRef, useEffect, useState } from "react";
import MessageHeader from "./MessageHeader";
// import MessageInput from "./MessageInput";
// import MessageContent from "./MessageContent";
import { MessagesMain } from "../styles/MessagesStyles";
// import SenderMessages from "./SenderMessages";
// import ReceiverMessage from "./ReceiverMessage";
import { MessageContentMain, MessageContainer } from "../styles/MessagesStyles";
import { CustomScrollbarStyle } from "../../../customer/messages/styles/ScrollbarStyles";
import SmallLoader from "../../../shared/loader/SmallLoader";
import { useSelector } from "react-redux";
import SenderMessages from "../../../customer/messages/SenderMessages";
import ReceiverMessage from "../../../customer/messages/ReceiverMessage";
import { GetSingleChatByID } from "../../../../services/admin/chat";
import MessageInput from "../../../customer/messages/MessageInput";
// import { MessageContainer } from "../../../customer/messages/styles/MessageMainStyles";

const MessageMain = ({ UserObj = {} }) => {
  const { user = {} } = useSelector((state) => state.auth);
  const [Page, setPage] = useState(1);
  const [isLastPage, setIsLastPage] = useState(false);
  const messageContainerRef = useRef(null);
  const [AllMessages, SetAllMessages] = useState([]);

  const [loading, setLoading] = useState(false);
  const [MessagesStatus, SetMessagesStatus] = useState([]);

  useEffect(() => {
    scrollToBottom();
  }, [AllMessages]);
  const scrollToBottom = () => {
    messageContainerRef.current.scrollTop =
      messageContainerRef.current.scrollHeight;
  };

  // call the api

  useEffect(() => {
    if (UserObj?.user_slug) {
      FetchSingleConversation();
    }
  }, [UserObj?.user_slug, Page]);

  const FetchSingleConversation = async () => {
    const resp = await GetSingleChatByID(setLoading, UserObj?.user_slug, Page);

    if (resp?.status === 200 && resp?.data?.message === "Success") {
      if (resp?.data?.data) {
        if (Page === 1) {
          if (resp?.data?.data) {
            if (Page === 1) {
              SetAllMessages(resp?.data?.data);
            } else {
              // const prevScrollHeight = messageContainerRef.current.scrollHeight;
              SetAllMessages((prevData) => [...prevData, ...resp?.data?.data]);
              // Adjust the scroll position after new data is loaded
              // const addedHeight =
              //   messageContainerRef.current.scrollHeight - prevScrollHeight;

              // messageContainerRef.current.scrollTop =
              //   prevScrollPositionRef.current + addedHeight;
            }
          }
        }
      }
      SetMessagesStatus(resp?.data);
    }
  };

  return (
    <MessagesMain>
      {!loading && (
        <MessageHeader
          UserName={UserObj?.user_name}
          UserImgUrl={UserObj?.user_image}
        />
      )}
      {/* message sections */}
      <MessageContentMain>
        <CustomScrollbarStyle ref={messageContainerRef}>
          <MessageContainer className="admin_messageContainer">
            {loading && <SmallLoader center={true} MT="10" />}
            {!loading && (
              <>
                {AllMessages &&
                  MessagesStatus?.message === "Success" &&
                  !MessagesStatus?.data && (
                    <span className="no_message_text">No Message.</span>
                  )}
              </>
            )}

            {!loading &&
              AllMessages &&
              AllMessages?.slice()
                ?.reverse()
                ?.map((message, index) => {
                  const Datakey = `${index}_${message?.sender_id}_${message?.id}`;

                  if (user?.id === message?.recipient_id) {
                    return (
                      <ReceiverMessage
                        key={Datakey}
                        message={message?.message}
                        date={message?.created_at}
                        attachments={message?.attachments_urls}
                      />
                    );
                  } else {
                    return (
                      <SenderMessages
                        key={Datakey}
                        message={message?.message}
                        date={message?.created_at}
                        attachments={message?.attachments_urls}
                      />
                    );
                  }
                })}
          </MessageContainer>
        </CustomScrollbarStyle>
      </MessageContentMain>

      {/* <MessageContent /> */}
      {!loading && (
        <MessageInput
          SetAllMessages={SetAllMessages}
          AllMessages={AllMessages}
          scrollToBottom={scrollToBottom}
          type="admin"
          sendTo={UserObj?.user_slug}
        />
      )}
    </MessagesMain>
  );
};

export default MessageMain;
